import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './app/App';
import { queryClient } from './app/queryClient';
import './styles/global.css';
import { markBrowserUi } from './lib/browserUi';

// Before the first render, so the tab bar never jumps.
markBrowserUi();

// iOS Safari only applies :active (the press feedback on tabs and buttons)
// once the page has a touchstart listener; an empty passive one is enough.
document.addEventListener('touchstart', () => {}, { passive: true });

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found.');
}

// Registered unconditionally (not just on push opt-in) since a controlling
// service worker is one of the criteria browsers use to decide a site is
// installable as a PWA. Re-registering the same script/scope on a later
// subscribe() call is a no-op against this same registration.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => {
    // Best-effort; push opt-in and installability just aren't available.
  });
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
